import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { HeadersPath, path } from '../../Utils/ScreenPath';
import CustomDropdown from '../../Common/CustomDropdown';
import { FileQuestion, Lock } from 'lucide-react';
import { Button } from '../../Common/Button';
import ChapterSelector from '../../Common/ChapterSelector';
import Exam from '../../assets/images/Exam.png';
import bookmark from '../../assets/images/bookmark.png';
import clipboard from '../../assets/images/clipboard.png';
import task from '../../assets/images/task.png'
import book from '../../assets/images/book.png';
import clipboardTick from "../../assets/images/clipboardTick.png"
import { ErrorToast } from '../../Common/Toast';
import { Api } from '../../Service/api';
import moment from 'moment';
import PrintModel from '../../Common/PrintModel';
import SubjectPurchase from '../../Common/SubjectPurchase';
import { Checkbox, Select } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const RandomGenerate = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
    const boardDataList = useSelector((state) => state?.Board?.BoardData || {});
    const mediumDataList = useSelector((state) => state?.Medium?.MediumData || {});
    const standardDataList = useSelector((state) => state?.Standard?.StandardData || {});
    const semesterDataList = useSelector((state) => state?.Semester?.SemesterData || {});
    const subjectDataList = useSelector((state) => state?.Subject?.SubjectData || {});


    const [selectedDrpData, setSelectedDrpData] = useState({
        board: '',
        medium: '',
        standard: '',
        semester: '',
        subject: '',
        chapter: [],
        withSection: false
    })

    const [selectedChapters, setSelectedChapters] = useState([])
    const [boardData, setBoardData] = useState([])
    const [mediumData, setMediumData] = useState([])
    const [standardData, setStandardData] = useState([])
    const [semesterData, setSemesterData] = useState([])
    const [subjectData, setSubjectData] = useState([])
    const [chapterData, setChapterData] = useState({})
    const [modelCall, setModelCall] = useState(false)
    const [isModelOpen, setisModelOpen] = useState(false)
    const [isPurchaseModelOpen, setIsPurchaseModelOpen] = useState(false)


    let buttonDisabled = selectedDrpData?.board && selectedDrpData?.medium && selectedDrpData?.standard && selectedDrpData?.subject && selectedDrpData?.semester && selectedChapters.length > 0 ? false : true

    const handleDropDownChange = (name, value) => {
        setSelectedDrpData({ ...selectedDrpData, [name]: value })
        if (name === "board") {
            setSelectedDrpData((prev) => ({
                ...prev,
                medium: '',
                standard: '',
                semester: '',
                subject: '',
                [name]: value
            }))
            setMediumData([])
            setStandardData([])
            setSemesterData([])
            setSubjectData([])
            setChapterData({})
            setSelectedChapters([])
        }

        if (name === "medium") {
            let payload = {
                ...selectedDrpData,
                standard: '',
                semester: '',
                subject: '',
                [name]: value
            }
            setSelectedDrpData(payload)
            setStandardData([])
            setSemesterData([])
            setSubjectData([])
            setChapterData({})
            setSelectedChapters([])
        }

        if (name === "standard") {
            let payload = {
                ...selectedDrpData,
                semester: '',
                subject: '',
                [name]: value,
            }
            setSelectedDrpData(payload)
            setSemesterData([])
            setSubjectData([])
            setChapterData({})
            setSelectedChapters([])
        }

        if (name === "semester") {
            let payload = {
                ...selectedDrpData,
                subject: '',
                [name]: value,
            }
            setSelectedDrpData(payload)
            setSubjectData([])
            setChapterData({})
            setSelectedChapters([])
        }

        if (name === "subject") {
            let payload = {
                ...selectedDrpData,
                [name]: value,
            }
            setSelectedDrpData(payload)
            setChapterData({})
            setSelectedChapters([])
        }

    }

    const handleSelectionChange = (selectedChapters) => {
        setSelectedChapters(selectedChapters)
    }

    const onIsLockedClick = (chapter) => {
        setIsPurchaseModelOpen(true)
    }

    const handleModelClose = () => {
        setisModelOpen(!isModelOpen)
    }

    const onAutoGenerateClick = async () => {
        if (!buttonDisabled) {
            const data = {
                board: selectedDrpData?.board,
                medium: selectedDrpData?.medium,
                standard: selectedDrpData?.standard,
                semester: selectedDrpData?.semester,
                subject: selectedDrpData?.subject,
                chapter: selectedChapters,
                withSection: selectedDrpData?.withSection,
            }
            dispatch(ACTIONS.getRandomGenerateData(data))
            navigate(path?.RandomGenerateQue)

        }
    }

    const handleGetBoard = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                isOthers: true,
            }
            dispatch(ACTIONS.getBoardData(params))
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const handleGetMedium = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                board: selectedDrpData?.board?.id,
                isOthers: true,
            }
            dispatch(ACTIONS.getMediumData(params))
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const handleGetStandard = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                medium: selectedDrpData?.medium?.id,
                isManual: true,
                isLearn: false,
            }
            dispatch(ACTIONS.getStandardData(params))
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const handleGetSemester = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                standard: selectedDrpData?.standard?.id,
                isManual: false,
                isLearn: false,
            }
            dispatch(ACTIONS.getSemesterData(params))
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const handleGetSubject = async (semesterId) => {
        dispatch(ACTIONS.startLoading())
        try {
            let params = {
                standard: selectedDrpData?.standard?.id,
                semester: selectedDrpData?.semester?.id,
                medium: selectedDrpData?.medium?.id,
                isManual: true,
                isLearn: false,
                limit: 1000,
                Offset: 1
            }
            dispatch(ACTIONS.getSubjectData(params))
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    const handleGetChapter = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let body = {
                standard: selectedDrpData?.standard?.id,
                semester: selectedDrpData?.semester?.id,
                subject: selectedDrpData?.subject?.id,
            }
            const { data } = await Api.GetChapter(body)
            const res = JSON.parse(data);
            if (res?.status === 200) {
                setChapterData(res)
            } else {
                ErrorToast(res?.message);
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }

    useEffect(() => {
        if (boardDataList?.status === 200) {
            setBoardData(boardDataList)
        }
    }, [boardDataList])

    useEffect(() => {
        // if(mediumDataList?.status === 200){
        setMediumData(mediumDataList)
        // }
    }, [mediumDataList])

    useEffect(() => {
        if (standardDataList?.status === 200) {
            setStandardData(standardDataList)
        }
    }, [standardDataList])

    useEffect(() => {
        if (semesterDataList?.status === 200) {
            setSemesterData(semesterDataList)
        }
    }, [semesterDataList])

    useEffect(() => {
        if (subjectDataList?.status === 200) {
            setSubjectData(subjectDataList)
        }
    }, [subjectDataList])

    useEffect(() => {
        if (selectedDrpData?.board) {
            handleGetMedium()
        }
    }, [selectedDrpData?.board])

    useEffect(() => {
        if (selectedDrpData?.medium) {
            handleGetStandard()
        }
    }, [selectedDrpData?.medium])

    useEffect(() => {
        if (selectedDrpData?.standard) {
            handleGetSemester()
        }
    }, [selectedDrpData?.standard])

    useEffect(() => {
        if (selectedDrpData?.semester) {
            handleGetSubject()
        }
    }, [selectedDrpData?.semester])

    useEffect(() => {
        if (selectedDrpData?.subject) {
            handleGetChapter()
        }
    }, [selectedDrpData?.subject])

    useEffect(() => {
        dispatch(ACTIONS.getHeaderPath(HeadersPath.RandomGenerate))
        handleGetBoard()
    }, [])

    const onPaymentSuccess = () => {
        if (selectedDrpData?.subject) {
            handleGetChapter();
        }
    };


    return (
        <div>
            <div style={{ color: "#DC0000", margin: "7px 0" }} className='lg:text-base text-sm '>
                સૂચના : ઓટો પેપર અને રેન્ડમ પેપર જનરેશન એ એક એક્સ્ટ્રા સુવિધા છે
                તેનો કોઈ અલગ થી ચાર્જ લેવામાં આવેલ નથી. (અંગ્રેજી, ગુજરાતી, સંસ્કૃત,
                હિન્દી, એકાઉન્ટ, એસ.પી. વગેરે વિષયમાં આ સુવિધા ઉપલબ્ધ નહીં મળે)
                વધારે માહિતી માટે 9712444548 પર સંપર્ક કરો.
            </div>

            <div className="flex flex-col gap-2 lg:gap-4">
                <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Board"
                            data={boardData?.data || []}
                            textKey="board_name"
                            onSelect={(e) => handleDropDownChange("board", e)}
                            defaultValue={selectedDrpData?.board?.board_name || "Select Board"}
                            icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
                        />
                    </div>
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Medium"
                            data={selectedDrpData?.board ? mediumData?.data : [] || []}
                            textKey="name"
                            onSelect={(e) => handleDropDownChange("medium", e)}
                            defaultValue={selectedDrpData?.medium?.name || "Select Medium"}
                            icon={<img src={bookmark} alt="Exam Icon" className="w-5 h-5" />}
                        />
                    </div>
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Standard"
                            data={selectedDrpData?.medium ? standardData?.data : [] || []}
                            textKey="name"
                            onSelect={(e) => handleDropDownChange("standard", e)}
                            defaultValue={selectedDrpData?.standard?.name || "Select Standard"}
                            icon={<img src={clipboard} alt="Exam Icon" className="w-5 h-5" />}
                        />
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Semester"
                            data={selectedDrpData?.standard ? semesterData?.data?.rows : [] || []}
                            textKey="semester"
                            onSelect={(e) => handleDropDownChange("semester", e)}
                            defaultValue={selectedDrpData?.semester?.semester || "Select Semester"}
                            icon={<img src={task} alt="task Icon" className="w-5 h-5" />}
                        />
                    </div>
                    <div className="w-full">
                        <CustomDropdown
                            title="Select Subject"
                            data={selectedDrpData?.semester ? subjectData?.data : [] || []}
                            textKey="subject"
                            onSelect={(e) => handleDropDownChange("subject", e)}
                            defaultValue={selectedDrpData?.subject?.subject || "Select Subject"}
                            icon={<img src={book} alt="book Icon" className="w-5 h-5" />}
                        />
                    </div>
                </div>
            </div>

            {Object.keys(chapterData).length > 0 &&
                <div style={{ margin: '10px 0' }}>
                    <h1 style={{ padding: '5px 0', fontWeight: '600' }} className='lg:text-xl text-lg '>
                        Select Chapter for Generate Exam Paper
                    </h1>
                    <div style={{ padding: '5px 0' }}>
                        <ChapterSelector chapters={chapterData} onSelectionChange={handleSelectionChange} onIsLockedClick={onIsLockedClick} />
                    </div>
                </div>
            }

            <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>
                <Checkbox
                    name="withSection"
                    id="withSection"
                    onChange={(e) => setSelectedDrpData((prev) => ({ ...prev, withSection: e.target.checked }))}
                    value={selectedDrpData?.withSection}
                />
                <span className='lg:text-lg text-sm text-gray-800'>Create exam paper with section</span>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
                <div style={{ width: '75px' }}>
                    <Button
                        id=""
                        type="button"
                        label={"Next"}
                        disabled={buttonDisabled}
                        onClick={onAutoGenerateClick}
                    />
                </div>
            </div>


            <PrintModel
                isModelOpen={isModelOpen}
                setisModelOpen={setisModelOpen}
                handleModelClose={handleModelClose}
                modelCall={modelCall}
                setModelCall={setModelCall}
                headerPath={HeadersPath.AutoGenerate}
                isEdit={"false"}
            />
            <SubjectPurchase
                isModelOpen={isPurchaseModelOpen}
                setIsPurchaseModelOpen={setIsPurchaseModelOpen}
                selectedDrpData={selectedDrpData}
                onPaymentSuccess={onPaymentSuccess}
            />
        </div>
    )
}

export default RandomGenerate